<template>
  <div class="app flex-row align-items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>{{ $t('login_title') }}</h1>
                <span class="text-muted">{{ $t('login_description') }}</span>
                <div class="clearfix"></div>
                <span v-show="error != null" class="text-danger">{{ error }}</span>
                <div class="clearfix"><br/></div>
                <b-form v-on:keydown.enter="login">
                  <b-input-group class="mb-3">
                    <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                    <b-form-input type="text" class="form-control"
                                  v-model="body.username"
                                  v-bind:placeholder="$t('username')"
                                  aria-describedby="username-feedback"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                    <b-form-input type="password" class="form-control"
                                  v-model="body.password" v-bind:placeholder="$t('password')"
                                  aria-describedby="password-feedback"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="5">
                      <b-button @click="login" variant="primary" class="px-4">{{ $t('login_title') }}</b-button>
                    </b-col>
                    <b-col cols="7" class="text-right">
                      <b-button variant="link" class="px-0">{{ $t('forgot_password') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center login-card-body" >
                <div>
                  <div class="login-language">
                    <change-language></change-language>
                  </div>
                  <div class="clearfix"></div>
                  <img src="static/img/logo.png" class="login-logo" alt="Central Hub">
                  <p style="display: none">
                    {{ $t('slogan')}}
                  </p>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <div class="login-copyright">copyright © 2018</div>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
  .login-language {
    width: 100px;
    float: right;
    margin-top: -10px;
  }
  .login-card-body {
    padding-top: 0px !important;
    margin-top: -20px !important;
  }
  .login-logo {
    width: 85%;
    margin-bottom: 20px;
  }
  .login-copyright {
    margin-top: 40px;
    margin-bottom: -30px;
  }
</style>

<script>
  import ChangeLanguage from '../../components/Partials/ChangeLangues.vue'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'Login',
    components: {
      ChangeLanguage
    },
    data () {
      return {
        body: {
          username: '',
          password: ''
        },
        error: null
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      body: {
        username: {
          required
        },
        password: {
          required
        }
      }
    },
    methods: {
      login () {
        this.$Progress.start()
        this.$auth.login({
          data: {
            username: this.body.username,
            password: this.body.password
          },
          headers: {
            'Accept': 'application/json'
          },
          success: function (response) {
            this.$Progress.finish()
            this.error = null
          },
          error: function (error) {
            this.$Progress.fail()
            this.$notify({
              title: this.$t('error'),
              text: error.response.data.message,
              type: 'error'
            })
            this.error = error.response.data.message
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/Login.vue